import React from 'react';
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from '@material-tailwind/react';
import { useTheme } from '@mui/material/styles';

const TabsUI = ({ activeTab, handleTabClick, children, alignToStart, disablePadding, multiRowTabs }) => {
  const theme = useTheme();
  const ui = theme.palette.ui;

  return (
    <Tabs value={activeTab} className="w-full">
      <TabsHeader
        className={`${
          alignToStart
            ? multiRowTabs
              ? 'flex flex-row justify-start mx-4'
              : 'inline-flex justify-start mx-4'
            : multiRowTabs
              ? 'mx-auto flex flex-row justify-center'
              : 'mx-auto flex flex-row'
        } ${multiRowTabs ? 'flex-wrap items-center gap-2' : 'overflow-x-auto custom-scrollbar tab-scroll'} -mb-6`}
        style={{ background: ui.tab }}
      >
        {React.Children.map(children, (tab, index) => {
          if (tab)
            return (
              <Tab
                key={index}
                value={index}
                onClick={() => handleTabClick(index)}
                className={`relative z-10 cursor-pointer ${alignToStart ? 'px-4' : ''} ${multiRowTabs ? 'flex-none w-auto' : ''}`}
                style={{ color: ui.primaryLabel }}
              >
                <div className={multiRowTabs ? 'whitespace-normal break-words' : 'truncate'}>{tab.props.name}</div>
              </Tab>
            );
        })}
      </TabsHeader>
      <TabsBody
        className={disablePadding ? 'mt-0' : 'mt-5'}
        animate={{
          initial: { y: 250 },
          mount: { y: 0 },
          unmount: { y: 250 },
        }}
      >
        {React.Children.map(children, (tab, index) => {
          if (tab) {
            return (
              <TabPanel key={index} value={index} className={disablePadding ? 'm-0 p-0' : ''}>
                {tab.props.children}
              </TabPanel>
            );
          }
        })}
      </TabsBody>
    </Tabs>
  );
};

export default TabsUI;
